"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require("babel-runtime/helpers/extends");

var _extends5 = _interopRequireDefault(_extends4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// get the anticipatory attribute from an object,
// get a matching job from a list of possibilities.
// below, this is used to prioritize getting a job
// from the reduced object if exists, or else
// grabbing it from the initial job array
var getJob = function getJob(slug) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  var foundJob = rest.reduce(function (job, el) {
    return job || el[slug];
  }, null);

  return foundJob || {};
};

var getPromotional = function getPromotional(job) {
  return job.promotional || [];
};
var getAnticipatory = function getAnticipatory(job) {
  return job.anticipatory || [];
};

// returns a new object, with the jobs specified in promotionalJobs
// iterated over and each job's anticipatory array joined with the specified
// slug
var getPopulatedAnticipatoryJobs = function getPopulatedAnticipatoryJobs(slug, promotionalJobs, obj, jobs) {
  return promotionalJobs.reduce(function (promoObj, promoJobSlug) {
    var promoJob = getJob(promoJobSlug, obj, jobs);
    var newPayload = (0, _extends5.default)({}, promoObj, (0, _defineProperty3.default)({}, promoJobSlug, (0, _extends5.default)({}, promoJob, {
      anticipatory: getAnticipatory(promoJob).concat(slug)
    })));
    return newPayload;
  }, {});
};

var getAnticipatoryJobs = function getAnticipatoryJobs(jobs) {
  return (0, _keys2.default)(jobs).reduce(function (obj, slug) {
    var job = getJob(slug, obj, jobs);

    return (0, _extends5.default)({}, obj, (0, _defineProperty3.default)({}, slug, job), getPopulatedAnticipatoryJobs(slug, getPromotional(job), obj, jobs));
  }, {});
};

exports.default = getAnticipatoryJobs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/data/getAnticipatoryJobs.js
// module id = 1287
// module chunks = 0